module.exports = __webpack_public_path__ + "static/media/pdf-icon-with-text.e84a661d.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/pdf-icon-with-text.svg
// module id = 1623
// module chunks = 1